module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("h6gTj"))).then(() => parcelRequire('1iHdE'));